<template >

  <v-app id="inspire">


    <h4 class="info-header">
    You are viewing an older version of MSDAT.
    <span >
      <a href="https://msdat.fmohconnect.gov.ng/dashboard/Health_Outcomes_and_Service_Coverage" class="info-header-link" target="_blank" rel="noopener noreferrer">Click here to move to new version.</a>
    </span>

    </h4>

    <!-- routeName !== '/new_nphcda_dashboard' -->
        <ul class="nav nav-tabs small toptab" id="toptab" role="tablist" style=" background-color:rgb(39, 81, 80);border:0px;">

                <!-- <li class="nav-item dropdown">
                  <a class="dropdown-toggle" type="button" data-toggle="dropdown" data-hover="dropdown">NHMIS Analysis <span class="caret"></span></a>
                  <ul class="dropdown-menu ">
                      <li class="nav-item"><a class="nav-link" href="#">COVID-19 Service Update</a></li>
                      <li class="nav-item"><a class="nav-link" href="#">Routine NHMIS Analysis</a></li>

                      <li class="nav-item"><a class="nav-link" href="#">NHMIS Insights</a></li>
                    </ul>

                </li> -->

                <li class="nav-item"><router-link to="/state_profile" :class="[currentPage.includes('state_profile')?activeClass:'']">State Profiles</router-link></li>
                <!-- <li class="nav-item"><router-link to="/health_facility_survey" :class="[currentPage.includes('health_facility_survey')?activeClass:'']">Health Facility Survey</router-link></li> -->
                <!-- <li class="nav-item"><a href="https://nhfs.msdat.fmohconnect.gov.ng/" target="blank">Health Facility Survey</a></li> -->



                <li class="nav-item dropdown">
                  <a class="dropdown-toggle" :class="[currentPage.includes('nhmis_analysis')?activeClass:'']" type="button" data-toggle="dropdown" data-hover="dropdown">NHMIS Analysis <span class="caret"></span></a>
                  <ul class="dropdown-menu ">
                      <li class="nav-item"><a href="https://msdat.old.fmohconnect.gov.ng/covid19_health_service_uptake/index.html" target="blank">Health Service Uptake</a></li>
                      <li class="nav-item"><router-link to="/nhmis_analysis" >Routine NHMIS Analysis</router-link></li>
                      <li class="nav-item"> <a href="http://monthly-nhmis-analysis.fmohconnect.gov.ng/" target="blank">NHMIS Insights</a></li>
                    </ul>

                </li>
                <li class="nav-item"><router-link to="/central_analytics" :class="[currentPage.includes('central_analytics')?activeClass:'']">MSDAT Platform</router-link></li>

            </ul>


    <v-toolbar color="green" dark app style="height: 52px; margin-top: -5px padding: 5px 0; border:0px solid green;box-shadow:  0 5px 5px -5px #333;">
      <img id="logo" src="static/img/fmoh_logo.png" width="150px"
                  class="img-responsive float-left pr-2"
                  style="border-right:1px solid #EEEEEE"
                  alt="Logo"
                  @click="goto('http://health.gov.ng')">
      <!-- <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon> -->
      <v-menu :nudge-width="90">

        <v-toolbar-title class="ml-0" slot="activator">
                <p class="navheader float-left pl-1 ml-2" v-if="this.$route.path === '/state_profile'">MSDAT State Health Profiles</p>
                <p id="name-title" class="navheader float-left pl-1 ml-2 " v-else>Multi-Source Data Analytics & Triangulation (MSDAT) Platform</p>

            <!-- </div> -->
        </v-toolbar-title>
      </v-menu>
        <!-- <v-spacer></v-spacer> -->
      <v-toolbar-items class=" float-right">
        <div class="car-nav">
          <span class="covid-menu" style="font-size:13px; text-align:right;">
            <a class="covid-button" id="covid-button" href="https://msdat.fmohconnect.gov.ng/covid19_health_service_uptake/index.html" style="margin-right:25px; text-decoration:none; border: 1px solid white; padding: 9px 10px">Health Service Uptake</a>
            <router-link to="/about" style="margin-right:25px; text-decoration:none; color: white;">About</router-link>
            <router-link to="/help" style="margin-right:25px; text-decoration:none; color: white;">Help and FAQs</router-link>
          </span>
          <div class="sections-button"  v-show="isMSDATPage">
            <button v-show="isMSDATPage" data-step="1" data-intro='<b>Jump To Section</b><p>You can jump to any section of the platform by selecting the desired section from the drop-down menu</p>' id="dropdown-button" class="material-button-raised tour-guide " @click="showNavigation()">Sections &nbsp;<span class="caret"></span></button>
            <div class="dropdown-div">

              <div id="navigation-dropdown " class="navigation-dropdown" v-show="showNavigationBool">
                <ul>
                  <li @click="goToZonalChart('zonalChart')">Zonal Section</li>
                  <li @click="goToZonalChart('compare-section')">Multi-Source Indicator Comparison Section</li>
                  <li @click="goToZonalChart('datasets')">Multi-Dataset Comparison Section</li>
                  <li> <a href="javascript:Userback.open();">
                    Feedback
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- This shows on smaller screens -->
          <div class="car-icons-container-sm" @mouseleave='offMoreMenu'>
            <span class="more-menu" @click='showMoreMenu'><v-icon v-tooltip.bottom="'Site Options'" medium class="white--text">more_vert</v-icon></span>
            <div class="dropdown-div" @mouseleave='offMoreMenu'>
              <div id="navigation-more-menu" class="navigation-dropdown navigation-more-menu"  v-if="showMoreMenuBool === true">
                <ul @click='offMoreMenu'>
                   <!-- <v-icon  v-show="isMSDATPage" large class="white-text" title="Use a tour guide" @click="startTour()">slideshow</v-icon>  -->


                  <li><router-link to="/about"><v-icon  class="" title="About">info</v-icon> <span style="padding-left:10px">About Dashboard</span></router-link> </li>
                  <!-- <li><a href="https://msdat.fmohconnect.gov.ng/covid/index.html">COVID-19 Service Update</a></li> -->

                  <li @click="startTour()"><v-icon  class="" title="Use a tour guide" >slideshow</v-icon>  <span style="padding-left:13px">Play Tour Guide</span></li>

                  <hr>

                  <li @click="shareDashboardState()"><v-icon  class=""  title="Share">share</v-icon> <span style="padding-left:13px">Share</span> </li>

                  <li @click="printPage()"><v-icon  class="" title="Print">print</v-icon>   <span style="padding-left:13px">Print </span></li>

                  <li @click="toggle()"><v-icon  class="" title="Fullscreen">fullscreen</v-icon>  <span style="padding-left:13px">View Fullscreen</span></li>

                  <hr>

                  <li><a href="https://mapping.fmohconnect.gov.ng/data-inventory/add-dataset/"> <v-icon  class=""  title="Submit new data source">file_upload</v-icon> <span style="padding-left:10px">Submit new Data Source</span></a></li>

                  <hr>

                  <li> <router-link to="updatelog"><img style="margin-left:8px" src="../static/img/icons/see-updates-icon.svg" alt="">  <span style="padding-left:10px">See Updates</span></router-link> </li>

                  <li><a href="javascript:Userback.open();"><img style="margin-left:8px" src="../static/img/icons/feedback-icon.svg" alt="">   <span style="padding-left:14px">Feedback</span></a></li>

                  <li><router-link to="/contact"><v-icon class="" title="Contact">email</v-icon> <span style="padding-left:10px">Contact</span></router-link></li>


                  <li><router-link to="/help"><v-icon  class="" title="Help">help</v-icon> <span style="padding-left:10px">Help and FAQs</span></router-link></li>
                  <li style="display: none"><img src="../static/img/icons/subscribe-icon.svg" alt="subscribe"> <span style="padding-left:19px">Subscribe to our newsletter</span></li>


                  <!-- <button class="material-button-raised tour-guide" @click="startTour()">Tour guide</button> -->
                  <!-- <router-link to="/about"><v-icon large class="white--text" title="About">info</v-icon></router-link>
                  <router-link to="/help"><v-icon large class="white--text" title="Help">help</v-icon></router-link>
                  <v-icon large class="white--text" @click="printPage()" title="Print">print</v-icon>
                    <v-icon large class="white--text" title="Fullscreen" @click="toggle()">fullscreen</v-icon>
                  <v-icon v-show="isMSDATPage" large class="white--text" @click="shareDashboardState()" title="Share">share</v-icon> -->
                  <!-- <v-icon large class="white--text" v-tooltip.bottom="'Email link'">mail_outline</v-icon> -->
                  <!-- <router-link to="/contact"><v-icon large class="white--text" title="Contact">email</v-icon></router-link> -->
                  <!-- <a href="https://mapping.fmohconnect.gov.ng/data-inventory/add-dataset/"> <v-icon large class="white--text"  title="Submit new data source">file_upload</v-icon></a> -->

                </ul>
              </div>
            </div>
          </div>

          <!-- This shows on larger screens -->
          <div class="car-icons-container-lg">
            <!-- <span class="car_icons text-xs-center text-sm-center text-md-center"> -->
               <!-- <v-icon  v-show="isMSDATPage" large class="white-text" title="Use a tour guide" @click="startTour()">slideshow</v-icon>  -->

                  <!-- <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          dark
          v-on="on"
        >
          Dropdown
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"

        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu> -->

              <!-- <button class="material-button-raised tour-guide" @click="startTour()">Tour guide</button> -->
              <!-- <router-link to="/about"><v-icon large class="white--text" title="About">info</v-icon></router-link>
              <router-link to="/help"><v-icon large class="white--text" title="Help">help</v-icon></router-link>
               <v-icon large class="white--text" @click="printPage()" title="Print">print</v-icon>
                <v-icon large class="white--text" title="Fullscreen" @click="toggle()">fullscreen</v-icon>
              <v-icon v-show="isMSDATPage" large class="white--text" @click="shareDashboardState()" title="Share">share</v-icon> -->
              <!-- <v-icon large class="white--text" v-tooltip.bottom="'Email link'">mail_outline</v-icon> -->
              <!-- <router-link to="/contact"><v-icon large class="white--text" title="Contact">email</v-icon></router-link>
              <a href="https://mapping.fmohconnect.gov.ng/data-inventory/add-dataset/"> <v-icon large class="white--text"  title="Submit new data source">file_upload</v-icon></a> -->

              <!-- <span>
                <b-dropdown position="is-bottom-left">
                  <v-icon data-step="8" data-intro='<b>Getting more help</b><p>To get futher assistant on how to use the dashboard, the dashboard help page can be accessed by clicking on the help button</p>' large class="white--text" slot="trigger" title="Help">help</v-icon>
                  <b-dropdown-item has-link>
                    <router-link to="/help"><b>App guide</b></router-link>
                  </b-dropdown-item>
                </b-dropdown>
              </span> -->
            <!-- </span> -->
          </div>

          <!-- <div class="col-xs-0 col-md-6">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center" id="fmoh_announcement" style="">
              <label class="white--text" style="visibility: hidden;">
                The Federal Ministry of Health (FMOH) Nigeria data analysis resource provides a single transparent view of key health indicators against
                multiple data sources.
                <span id="" style="font-weight: normal;">
                  This resource is managed by the Department of Health Planning Research and Statistics (DHPRS).
                </span>
              </label>
            </div>
          </div> -->


        </div>
      </v-toolbar-items>
      <v-spacer></v-spacer>
    </v-toolbar>

    <main>
      <v-content>
        <template v-if="$route.matched.length">
          <!-- wrap fullscreen around the route-view -->
          <fullscreen ref="fullscreen" @change="fullscreenChange" :fullscreen.sync="fullscreen">
            <!-- <transition name="slide-right" mode="out-in"> -->
              <router-view></router-view>
            <!-- </transition> -->
          </fullscreen>
        </template>
      </v-content>
    </main>
  <br><br>
    <v-footer id="footer" color="green" class="col-md-12 pa-3" app style="width:100%; height: 35px; font-size: 12px; position: fixed; bottom: 0;">
      <div class="col-md-7 col-sm-6 col-xs-4 " >
        <v-spacer></v-spacer>
        <div id="footerTextLeft" class="white--text footer-text" style="line-height: 11px;">Built with <label style="color:red;">&#9829;</label> by
        <a href="https://ehealth4everyone.com" target="_blank" class="white--text">eHealth4everyone</a>
         <!-- <span class="pull-right">&nbsp; &copy; {{ new Date().getFullYear() }}</span> -->
        </div>

      </div>
      <div class="col-md-5 col-sm-6 col-xs-8 white--text" style="text-align: right;">
        <v-spacer></v-spacer>
        <!-- v1.4.2 -->

        <div id="footerTextRight" class="footer-text" style="line-height: 15px;">{{this.$store.state.CAR.indicatorLength}} Indicators, {{this.$store.state.CAR.sourceMetaData}} Data sources. <router-link to="/updatelog" class="update-log" v-tooltip.top="'See UpdateLog'">Last Updated: 19-Sept-2022</router-link></div>
        <!-- 46 Indicators, 16 Data sources. -->
      </div>
    </v-footer>
  </v-app>

</template>


<script src="../public/js/jquery3.1.1.min.js"></script>
<script src="../node_modules/bootstrap/dist/js/bootstrap.min.js"></script>




<script>
import axios from "axios";
import {indDB} from './main';
  import auth from './components/Auth/auth'
  import html2pdf from 'html2pdf.js';
  // import Menu from './components/DPRS/dprs-src/components/Menu.vue'
  // import Footer from './components/DPRS/dprs-src/components/Footer.vue'
  import carousel from 'vue-owl-carousel'
  import { scrypt } from 'crypto';
  import VueCookies from 'vue-cookies'
  export default {
    components:{
    // 'fmoh-menu': Menu,
    // 'app-footer': Footer,
    carousel

  },
    data () {
      return {
         syncData:[],
        //////////////////////////////////////////////////////
        //SUB DASHBOARDS ACTIVE TAB STYLE
        activeClass: 'active',
        currentUrl:"",
        //////////////////////////////////////////////////////
        showNavigationBool: false,
        showMoreMenuBool: false,
        showSections: false,
        fullscreen: false,
        drawer: false,
        isTourActive: false,
        isTourStarts: false,
        tourButton: true,
        shareCounter: 0,
        // user location
        location: 'Guest',
        URLsToAccess: {
          "FMOHDirectorDPRS": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard"], //"/inventory_dashboard"],
          "FMOHDPRSMnE": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard"], //"/inventory_dashboard"],
          "PERM.Sec.FMOH": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard"], //"/inventory_dashboard", "/new_nphcda_dashboard"],
          "FMOHPublicHealth": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard"],
          "FMOHICT": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard", "/hmh_dashboard"], //"/inventory_dashboard"],
          "NPHCDAED": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard", "/nphcda_dashboard", "/new_nphcda_dashboard", "/nphcda_summary_dashboard"],
          "NPHCDADPRS": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard", "/nphcda_dashboard", "/new_nphcda_dashboard", "/nphcda_summary_dashboard"],
          "Admin": ["/nhmis_reporting", "/nhmis_analysis", "/car_dashboard", "/hmh_dashboard", "/inventory_dashboard", "/nphcda_dashboard",
                    "/new_nphcda_dashboard", "/nphcda_summary_dashboard", "/dashboard_usage"]
        },
        URLsNames: { "/nhmis_reporting": "NHMIS", "/nhmis_analysis": "NHMIS Monthly Analysis", "/car_dashboard": "CAR",
                    "/hmh_dashboard": "HMH", "/inventory_dashboard": "Inventory",
                    "/nphcda_dashboard": "Vaccine Wastage", "/new_nphcda_dashboard": "Weekly Immunization",
                    "/nphcda_summary_dashboard": "Routine Immunization", "/dashboard_usage": "Dashboard Usage"
        },
        SettingsItems: [
          'A', 'B', 'C'
        ],
        nameLookUp: {
          "CAR": `Central<br/>Analytics`,
        },
        //auth
        loggedIn: auth.loggedIn(),

      }


    },
   async mounted () {



          var ifConnected = window.navigator.onLine;

                if (ifConnected) {

                    try {

                          window.setInterval(() => {

                               this.synchDatabases();

                          }, 1000000);

                    } catch (e) {
                      // console.error(e)
                    }
                    // console.log(this.syncData);

                }
        },
    methods:{




 async synchDatabases(){

                  indDB.sub_dashboard_interests.each(sub_dashboard_interest => {this.syncData.push(sub_dashboard_interest);});
                      let datas = this.syncData
                          console.log(datas)
                          datas.forEach(data => {
                            let payload = data



                                                     axios.post('http://172.93.50.34:9000/api/v1/subDashboardInterest', payload)
                                                      .then(function (response) {
                                                        console.log(response.status);

                                                         let res = response.status

                                                              if (res == 201) {
                                                                  // console.log("-")
                                                                  // console.log("--")
                                                                  // console.log("---")
                                                                  // console.log("----")
                                                                  // console.log("User Added")
                                                                  // console.log("----")
                                                                  // console.log("---")
                                                                  // console.log("--")
                                                                  // console.log("-")


                                                                  // console.log("-")
                                                                  // console.log("--")
                                                                  // console.log("---")
                                                                  // console.log("----")
                                                                  // console.log("Removing Record from Ofline Database Now ...")
                                                                  // console.log("----")
                                                                  // console.log("---")
                                                                  // console.log("--")
                                                                  // console.log("-")


                                                              indDB.sub_dashboard_interests.clear();

                                                                  // console.log("-")
                                                                  // console.log("--")
                                                                  // console.log("---")
                                                                  // console.log("----")
                                                                  // console.log("Record removed from Ofline Database ")
                                                                  // console.log("----")
                                                                  // console.log("---")
                                                                  // console.log("--")
                                                                  // console.log("-")


                                                            }
                                                      })

                                                      .catch(function (error) {
                                                        console.log(error);
                                                      });
                                                         this.syncData.splice(0, this.syncData.length);

                       });
                       indDB.sub_dashboard_interests.count(function(count) {
                              console.log(count);
                            });
                },



      showNavigation(){
        this.showNavigationBool = !this.showNavigationBool;
      },
      offMoreMenu(){
      if (this.showMoreMenuBool == true) {
        this.showMoreMenu()
      }
      },
      showMoreMenu(){
        // this.showMoreMenuBool = !this.showMoreMenuBool;
     this.showMoreMenuBool == false ?  this.showMoreMenuBool = true :  this.showMoreMenuBool = false
      },
      nhmis(){
        this.$router.push({ path: `/` });
      },
      toggle () {

        this.$refs['fullscreen'].toggle();
      },
      enter(){
          return true
      },
      fullscreenChange (fullscreen) {
        this.fullscreen = fullscreen;
        this.$store.dispatch('fullscreen',fullscreen);
      },
      // tour guide function
      startTour() {
        this.isTourActive = false;
        // Instance the tour
        this.isTourStarts = false;
        introJs().start();
      },
      // print window function
      printPage(doc){
        window.print();
      },
      // go to url
      goto(url) {
        window.open(url)
        //location.href = "https://mapping.fmohconnect.gov.ng/data-inventory/add-dataset/";
      },
      // convert page to pdf
      convertToPDF(element_id) {
        var element = document.getElementById(element_id);
        var opt = {
          margin:       1,
          filename:     'central_analytics_dashboard.pdf',
          image:        { type: 'jpeg', quality: 0.98 },
          html2canvas:  { scale: 2 },
          jsPDF:        { unit: 'mm', format: 'a2', orientation: 'l' }
        };
        // New Promise-based usage:
        html2pdf().from(element).set(opt).save();
      },
      getNameLookUP (name) {
        return this.nameLookUp[name];
      },

      startSlideTimer() {
        // var counter = 0;
        // var slideTime = auth.getLocation() === "NERICC"? 360000: 300000;
        // this.URLsToAccess[auth.getLocation()].map( (elem, index) => {
        //   if (elem === '/new_nphcda_dashboard'){
        //     counter += 540000;
        //   }else{
        //     counter += slideTime;
        //   }
        //   setTimeout( () => {
        //     this.$router.push({ path: elem });
        //   }, counter)
        // })
      },

      isActiveLoc(param) {
        return this.$route.path === param;
      },
      getSideMenuItems() {
        // var userLocations = this.URLsToAccess[auth.getLocation()];
        // var items = [];

        // this.sideMenuItems.map( (elem, index) => {
        //   if (userLocations.includes(elem.route)) {
        //     items.push(elem);
        //   }
        // });
        // this.items[0].items = items;
      },
      goToZonalChart(e){
        this.$store.dispatch('goToZonalChart',e); // dispatched to store to be used in MainCARDashboard
      },
      shareDashboardState() {
        this.$store.dispatch('storeShareCounter');
      },
      reloadData() {
        let confirmation = window.confirm("Are you sure you want to refresh Platform Data?");
        if(confirmation) {
          this.$store.dispatch('reloadData');
        }
      }
    },
    props: {
      source: String
    },
    computed: {


      isCentralAnalytics() {
        var url = this.$route.path;
        var CAR_path = ['/central_analytics', '/car_dashboard', '/fmoh_car', '/help', '/about'];
        if (CAR_path.includes(url)) {
          return true;
        }
        return false;
      },
      isMSDATPage () {
        var url = this.$route.path;
        var MSDATPage = ['/central_analytics', '/car_dashboard'];
        if (MSDATPage.includes(url)) {
          return true;
        }
        return false;
      },


      isAdmin() {
        return auth.getLocation() === 'Admin';
      },
      routeName: function(){
        return this.$route.path;
         // this.$router.options.routes,
      },
      userLocations () {
        // console.log(auth.getLocation(), this.URLsToAccess[auth.getLocation()]);
        this.getSideMenuItems();
        this.startSlideTimer();
        this.loggedIn;
        return []; //this.URLsToAccess[auth.getLocation()];
      },

      //////////////////////////////////////////////////////
      //SUB DASHBOARDS
      currentPage(){
        return this.$route.path;


      }
      //////////////////////////////////////////////////////
    },
    created () {
      auth.onChange = loggedIn => {
        this.loggedIn = loggedIn
      }
      this.currentUrl = this.$route.path;
      // if(this.$route.path === "/state_profile"){
      //                console.log("MSDAT State Health Profiles")
      //           }else{
      //              console.log("Multi-Source Data Analytics & Triangulation (MSDAT) Platform")
      //           }


    },
    updated(){
      // let covid_button = document.getElementById("covid-button");
      let dropdown = document.getElementById("navigation-dropdown");
      let button = document.getElementById("dropdown-button");
      let section_dropdown = document.getElementById("section-dropdown");
      window.addEventListener('scroll',()=> {
        this.showNavigationBool = false;
        this.showMoreMenuBool = false;
      });
      // window.addEventListener('click',()=> {
      //   this.showNavigationBool = false;
      //   this.showMoreMenuBool = false;
      // });
      window.addEventListener('click',(event)=> {
        if(button === event.target || section_dropdown === event.target/* || covid_button === event.target*/){
          this.showMoreMenuBool = false;
        } else {
          this.showNavigationBool = false;
        }
      });
    },
    watch: {
      loggedIn(val) {
        this.getSideMenuItems();
        this.startSlideTimer();
      },
      // // watch for route changes
      // '$route' (to, from) {
      //   // needed to restart the timer after the last route has been visited; cyclical
      //   this.getSideMenuItems();
      //   var urlsArray = this.URLsToAccess[auth.getLocation()];
      //   var lastUrlInArray = urlsArray[urlsArray.length - 1];
      //   // console.log(lastUrlInArray);
      //   if (this.$route.path === lastUrlInArray) {
      //     this.startSlideTimer();
      //   }
      //   if( !lastUrlInArray.includes(this.$route.path) ) {
      //     this.$router.replace({path: this.$route.path});
      //   }


      // }


    }
    // computed: {
    //   avatarSize () {
    //     return `${this.slider}px`
    //   }
    // }@import './stylus/main'
     // @import '~vuetify/src/stylus/main'
  }

</script>

<style lang="stylus">

</style>

<style lang="less">
@import "../node_modules/bootstrap/less/bootstrap.less";
</style>

<style lang="sass">

</style>

<style scoped>
  /*
  Take this one to lang=`stylus` up above
   @import './stylus/main'
  */
  /* @import "./custom-bootstrap.scss"; */
  /* @import "../node_modules/vuetify/dist/vuetify.min.css"; */

  /* @import "../node_modules/buefy/node_modules/bulma/bulma.sass"; */

  /* @import "./assets/css/dropdown/css/bootstrap.min.css"; */
  /* @import "./assets/css/dropdown/css/animate.min.css"; */

  @import "./assets/css/styles.css";
  .info-header{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 66px;
    font-size: 20px;
    color: #000000a1;
  }

  .info-header-link{
    color: inherit;
    margin-left: 4px;
  }


  .info-header-link:hover{
    /* font-weight: bold; */
    color: black;
  }

  .covid-menu a {
    color: white;
  }
  .covid-menu .covid-button:hover {
    background-color: white;
    color: black;
    font-weight: bold;
  }
  .sections-button #dropdown-button {
    background-color: #007D53;
  }
  .sections-button #dropdown-button:hover {
    background-color: white;
    color: black;
    font-weight: bold;
  }
  .update-log{
    color: white !important;


  }
   #toptab li {
      float: right;
    }
    #toptab li a{
      font-family: 'Muli', sans-serif !important;
      color: white;
      font-size:11px;
      font-weight:550;
      margin-top: 3px;
      border: 0px;
    }
    #toptab li a:hover{
        background-color: rgb(9, 107, 74);
        color:#fff !important ;
    }


    .active{
       background-color:#007D53 !important ;
       color: white !important ;
       font-weight:600;
    }


            #toptab  .dropdown:hover .dropdown-toggle {
              /* background-color: rgb(39, 81, 80); */
              background-color: #242424 ;
              font-family: 'Muli', sans-serif !important;
              /* color:#fff !important ; */
              color:#fff !important ;

            }

            .dropdown-menu {
              border: 0px;
              display: none;
              position: absolute;
              background-color: white;
              min-width: 150px;
              box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
              /* z-index: 1; */
              /* right: 2px; */
              /* left: auto; */
              z-index: 10000;
              right: 2px;
              left: auto;

            }

            .dropdown-menu li {
              float: left !important;
              text-align: left;
              width: 100%;
            }

            .dropdown-menu li a {
              float: left !important;
              padding: 12px 16px;
              text-decoration: none;
              display: block;
              text-align: left;
              width: 100%;
              color: #5A5A5A !important;
              font-size: 12px !important;
            }
            .dropdown-menu li a:active {
              color: #fff !important;
            }

            .dropdown-menu li a:hover {
              background-color:#007D53 !important ;
              color:#fff !important ;
            }

            .dropdown:hover .dropdown-menu {
              display: block;
            }
            .navheader{
              font-family: 'Muli', sans-serif !important;
              text-align: left !important;
              font-size: 15px !important;
              font-weight: bold;
              letter-spacing: 0px !important;
              color: #FFFFFF !important;
              z-index: 10000;
            }
            .tour-guide {
               font-family: 'Muli', sans-serif !important;
              /* background-color: #007D53 !important;  */
              border: 1px solid white !important;
              color: #fff;
              font-size: 13px;
              padding: 0 25px;
            }
            .material-button-raised {
                position: relative;
                display: inline-block;
                box-sizing: border-box;
                margin: 0 8px;
                border: none;
                border-radius: 2px;
                padding: 0 16px;
                min-width: 64px;
                height: 36px;
                vertical-align: middle;
                text-align: center;
                text-overflow: ellipsis;
                text-transform: none !important;
                color: white;
                background-color: white;
    }
            .navigation-dropdown  {
                margin-top: 7%;
                border-radius: 4px;
            }
            .navigation-dropdown ul {
                padding: 2%;
            }
            .navigation-dropdown ul li {
                font-family: 'Muli', sans-serif !important;
                text-align: left;
                font:  10px ;
                letter-spacing: 0px;
                color: #5A5A5A;
                opacity: 1;
                padding: 2%;
            }
            .navigation-dropdown ul li:hover {
                background-color: transparent;
                color: #007D53;
            }


            .navigation-dropdown ul li a {
                font-family: 'Muli', sans-serif !important;
                text-align: left;
                font:  10px ;
                letter-spacing: 0px;
                color: #5A5A5A;

            }
            .navigation-dropdown ul li a:hover {
                background-color: transparent;
                color: #007D53 !important;
            }
            .nav > li > a:hover, .nav > li > a:focus{
                background-color: transparent !important;
            }

            @media only screen and (max-width : 1159px) {
              #name-title {
                    display: none;
                }
            }


            @media only screen and (max-width : 720px) {
              .covid-menu {
                    display: none;
                }
            }
            @media only screen and (max-width : 700px) {
                .navheader {
                    display: none;
                }
                #logo {
                    border-right: 0px solid #EEEEEE !important;
                }
            }
</style>



// WEBPACK FOOTER //
// App.vue?0518c35d